import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebaseConfig";
import { obtenerTiendasCercanas } from "../geo/tiendasCercanas";
import { obtenerResumenResenas } from "../geo/resenas";

const MAX_PRODUCTOS = 8;
const MAX_POR_TIENDA = 3; // evita que una sola tienda ocupe toda la sección

/**
 * Productos de las tiendas más cercanas al usuario (dentro del radio configurado).
 * Llama a setProducts con la lista y, opcionalmente, a onMeta({ fueraDeRango }).
 */
export const getProductosCerca = async (ubicacionUsuario, userFavorites, setProducts, onMeta) => {
  try {
    const tiendas = await obtenerTiendasCercanas(ubicacionUsuario);
    const seleccion = [];

    for (const tienda of tiendas) {
      if (seleccion.length >= MAX_PRODUCTOS) break;
      const productosTienda = await obtenerProductosDeTienda(tienda.vendedorUid, userFavorites);
      for (const p of productosTienda.slice(0, MAX_POR_TIENDA)) {
        if (seleccion.length >= MAX_PRODUCTOS) break;
        seleccion.push({ ...p, distancia: tienda.distancia, tiendaNombre: tienda.nombre });
      }
    }

    const resumen = await obtenerResumenResenas("idProducto", seleccion.map((p) => p.id));
    const conResenas = seleccion.map((p) => {
      const r = resumen[p.id];
      return { ...p, calificacion: r ? r.suma / r.cantidad : 0, resennaCount: r ? r.cantidad : 0 };
    });

    setProducts(conResenas);
    if (onMeta) onMeta({ fueraDeRango: tiendas.some((t) => t.fueraDeRango), sinTiendas: tiendas.length === 0 });
  } catch (error) {
    console.error("Error al obtener productos cercanos:", error.message);
    setProducts([]);
  }
};

export const obtenerProductosDeTienda = async (tiendaId, userFavorites) => {
  try {
    const snap = await getDocs(query(collection(db, "productos"), where("vendedorUid", "==", tiendaId)));
    const favoritos = (userFavorites && userFavorites.productos) || [];
    return snap.docs
      .map((d) => ({ ...d.data(), id: d.id }))
      .filter((p) => !p.pausa && !p.deshabilitado && p.stock > 0)
      .map((p) => ({ ...p, isFavorite: favoritos.includes(p.id) }));
  } catch (error) {
    console.error("Error al obtener productos de la tienda:", error.message);
    return [];
  }
};
